import { twMerge } from "tailwind-merge";

export const SpotlightSharedCardContainer = ({
  className,
  children,
  onClick,
}: {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        "flex min-w-[200px] flex-col gap-4 overflow-hidden rounded-lg",
        className,
      )}
    >
      {children}
    </div>
  );
};
